import { Mutation } from 'vuex';
import { IModuleState } from './types';

// 品牌列表(有权限)
export const setBrands: Mutation<IModuleState> = (state, payload) => {
  state.list.data = payload.data;
  state.list.pageNum = payload.pageNum;
  state.list.pageSize = payload.pageSize;
  state.list.total = payload.total;
  state.list.loading = !!payload.loading;
};

// 品牌列表(无权限)
export const setDataBrands: Mutation<IModuleState> = (state, payload) => {
  state.dataBrands.data = payload.data;
  state.dataBrands.pageNum = payload.pageNum;
  state.dataBrands.pageSize = payload.pageSize;
  state.dataBrands.total = payload.total;
  state.dataBrands.loading = !!payload.loading;
};

// 所有可用于关联的品牌列表(包含已关联和未关联的下游品牌)
export const setAllSubBrands: Mutation<IModuleState> = (state, payload) => {
  state.allSubBrands.data = payload.data;
  state.allSubBrands.pageNum = payload.pageNum;
  state.allSubBrands.pageSize = payload.pageSize;
  state.allSubBrands.total = payload.total;
  state.allSubBrands.loading = !!payload.loading;
};

// 已关联的下游品牌
export const setSubBrands: Mutation<IModuleState> = (state, payload) => {
  state.subBrands.data = payload.data;
  state.subBrands.pageNum = payload.pageNum;
  state.subBrands.pageSize = payload.pageSize;
  state.subBrands.total = payload.total;
  state.subBrands.loading = !!payload.loading;
};

// 所有可授权的组织列表(包含已授权和未授权)
export const setAllAuthOrgs: Mutation<IModuleState> = (state, payload) => {
  state.allAuthOrgs.data = payload.data;
  state.allAuthOrgs.pageNum = payload.pageNum;
  state.allAuthOrgs.pageSize = payload.pageSize;
  state.allAuthOrgs.total = payload.total;
  state.allAuthOrgs.loading = !!payload.loading;
};

// 已授权的组织列表
export const setAuthedOrgs: Mutation<IModuleState> = (state, payload) => {
  state.authedOrgs.data = payload.data;
  state.authedOrgs.pageNum = payload.pageNum;
  state.authedOrgs.pageSize = payload.pageSize;
  state.authedOrgs.total = payload.total;
  state.authedOrgs.loading = !!payload.loading;
};

// 品牌详情
export const setBrandDetail: Mutation<IModuleState> = (state, payload) => {
  state.detail.data = payload.data;
  state.detail.loading = !!payload.loading;
};

// 弹窗
export const setDialog: Mutation<IModuleState> = (state, payload) => {
  state.dialog.visible = !!payload.visible;
  state.dialog.loading = !!payload.loading;
};

// 确认弹窗
export const setConfirm: Mutation<IModuleState> = (state, payload) => {
  state.confirm.visible = !!payload.visible;
  state.confirm.loading = !!payload.loading;
  state.confirm.title = payload.title;
  state.confirm.content = payload.content;
  state.confirm.active = payload.active;
};

// 设置列表搜索条件
export const setSearchParams: Mutation<IModuleState> = (state, payload) => {
  state.searchParams = payload;
};

export const setLoading: Mutation<IModuleState> = (state, payload) => {
  state.loading = !!payload;
};
